export default "__VITE_ASSET__b83c1ba0__"